import React from 'react';
import { CheckIcon, InfoIcon } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { OfferBox } from '../ui/OfferBox';
import { volumes } from '../../data/volumes';
export function Volumes() {
  return <section className="w-full bg-ink px-4 py-16 md:py-24" data-id="element-317" data-mp="2wzp1oszvozea">
      <div className="mx-auto max-w-5xl" data-id="element-318" data-mp="2t07v1w8ptw7j">
        <SectionHeader tone="dark" kicker="Inside the Hair Transplant Blueprint™" title="6 Specialized Volumes to Organize Your Professional Learning" intro={['Each volume focuses on a distinct area of hair restoration education.', 'Together, they provide an organized reference collection covering anatomy, patient assessment, hairline design, donor area considerations, clinical documentation, and follow-up.']} data-id="element-319" data-mp="2szevbf86c6yw" />

        <div className="mt-12 space-y-6" data-id="element-320" data-mp="259aqx5n5w36u">
          {volumes.map(volume => <article key={volume.numeral} className="overflow-hidden rounded-3xl bg-navy" style={{
          boxShadow: `inset 0 4px 0 0 ${volume.accent}`
        }} data-id="element-321" data-mp="20cbyqsn266ba">
              <div className="p-6 md:p-9" data-id="element-322" data-mp="37xxesdxym7f6">
                <div className="flex items-center gap-4" data-id="element-323" data-mp="2u4xwy5apg14g">
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl font-display text-2xl font-black text-white" style={{
                backgroundColor: volume.accent
              }} data-id="element-324" data-mp="2u6irvw0xlm2u">
                    {volume.numeral}
                  </span>
                  <p className="font-display text-sm font-extrabold uppercase tracking-wider text-white/60" data-id="element-325" data-mp="3qufbl9ro0xia">
                    Volume {volume.numeral}
                  </p>
                </div>
                <h3 className="mt-4 text-balance font-display text-2xl font-black leading-tight text-white md:text-3xl" data-id="element-326" data-mp="3hspdjl3a30bj">
                  {volume.title}
                </h3>
                <p className="mt-2 text-lg font-bold" style={{
              color: volume.accent
            }} data-id="element-327" data-mp="26g50m7q67r9b">
                  {volume.tagline}
                </p>

                <div className="mt-6 grid gap-6 lg:grid-cols-[1fr_1.1fr]" data-id="element-328" data-mp="c0zjpyg884ue">
                  <div className="space-y-3 text-[16px] leading-relaxed text-white/75" data-id="element-329" data-mp="70tzh3cadkmc">
                    {volume.description.map(p => <p key={p} data-id="element-330" data-mp="3udeabd1fphm5">{p}</p>)}
                  </div>
                  <div className="rounded-2xl bg-navy-2 p-5" data-id="element-331" data-mp="3pe1n2r6ni8j1">
                    <p className="font-display text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-332" data-mp="3pfmdc4lxn5b3">What you’ll explore</p>
                    <ul className="mt-4 space-y-3" data-id="element-333" data-mp="3khb33srq6ssc">
                      {volume.explore.map(item => <li key={item} className="flex items-start gap-3" data-id="element-334" data-mp="3bea3maxd7zxn">
                          <CheckIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
                      color: volume.accent
                    }} strokeWidth={3} aria-hidden="true" data-id="element-335" data-mp="3bgd2lkghx3ei" />
                          <span className="text-[16px] leading-snug text-white/90" data-id="element-336" data-mp="19mnhonsbyv81">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>

                <p className="mt-6 flex gap-2 text-sm italic leading-relaxed text-white/55" data-id="element-337" data-mp="2wileqmmgwzh7">
                  <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 not-italic" aria-hidden="true" data-id="element-338" data-mp="31befz0iq9poj" />
                  {volume.note}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-14" data-id="element-339" data-mp="28mzd1ccvextk">
          <OfferBox ribbon="Get all 6 educational volumes" heading="Receive the complete HAIR TRANSPLANT BLUEPRINT™ collection." ctaLabel="Get the complete collection" ctaSub="$27 USD — One-time payment · Digital product · No recurring subscription" data-id="element-340" data-mp="28o0r7pp6o0fi" />
        </div>
      </div>
    </section>;
}